<template>
    <v-menu v-model="notificationsVisible" transition="scale-transition">
        <template v-slot:activator="{ props }">





            <v-btn rounded-circle icon v-bind="props" class="button__notification"
                :class="notificationsVisible ? 'button__notification--active' : 'button__notification--inactive'">


                <div class="button__notification__badge d-flex flex-row align-center justify-center"
                    v-if="unredNotifications.length > 0">
                    {{ unredNotifications.length }}
                </div>

                <v-icon>
                    <bell-white></bell-white>
                </v-icon>


            </v-btn>
        </template>



        <notifications-panel @close="notificationListClosed" />



    </v-menu>
</template>








<script lang="ts" setup>

import { computed, ref, watch } from "vue";
import BellWhite from "@/icons/BellWhite.vue";
import { NotificationsStore } from "@/store/NotificationsStore";
import NotificationsPanel from "@/components/Notification/Notifications-Panel.vue";

const notificationsVisible = ref(false);

const notificationStore = NotificationsStore();

const unredNotifications = computed(() => {
    return notificationStore.notifications.filter((notification) => notification.readAt === null);
});

const notificationListClosed = () => {
    notificationsVisible.value = false;
};

watch(notificationsVisible, (value) => {
    if (!value) {
        notificationStore.markAllAsRead();
    }
});

</script>